import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 1600px;
    margin: auto;
    padding: 0 20px;

    @media (max-width: 1600px) {
        width: 100%;
        padding: 0 20px;
    }
`

export const ContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: left;
    width: 100%;
`

export const FormContainer = styled.div`
    display: flex;
    width: 80%;
    margin: auto;
    flex-direction: column;
    justify-content: center;
`

export const FormTitle = styled.p`
    font-size: 20px;
    font-weight: 700;
    justify-self: flex-start;
`
